import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { Textfit } from 'react-textfit';

/**
 * @param {user} 로그인 후 얻은 User 정보 객체
 * @returns 프로필 이미지와 이름으로 구성된 User 프로필 뷰
 */
function UserProfile({ user }) {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)

    // UserInfoContainer 클릭 시 토글
    const toggleMenu = () => {
        setOpen(prev => !prev);
    };

    const logout = () => {
        navigate("/auth/logout")
    }

    // 팝업 바깥 클릭 시 닫기
    const handleClickOutside = e => {
        if (!e.target.closest('#user-info')) {
        setOpen(false);
        }
    };
    useEffect(() => {
        if (open) document.addEventListener('click', handleClickOutside);
        else document.removeEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [open]);

    return (
        <UserInfoContainer id="user-info" onClick={toggleMenu}>
        <UserImg 
            src={process.env.REACT_APP_RES_PATH + user.profile_image_url}
            alt="Knotter 이미지"
            onError={e => {
                e.currentTarget.onerror = null
                e.currentTarget.src = "/image/icn_profile_image_default.svg"
            }}
        />
        <Info>
          {user.name} <span id="name-ko">({user.name_ko})</span>
          <div id="email"><Textfit mode="single" max={16} style={{width: "180px"}}>{user.email}</Textfit></div>
        </Info>

        {open && (
            <ContextMenu>
              {/* <ContextMenuItem onClick={() => alert('설정')}>설정</ContextMenuItem> */}
              <ContextMenuItem onClick={logout}>로그아웃</ContextMenuItem>
            </ContextMenu>
        )}
        </UserInfoContainer>
    );
}

// 사용자 정보 컨테이너
const UserInfoContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 12px;
  cursor: pointer;
`;

const UserImg = styled.img`
  width: 56px;
  height: 56px;
  max-width: 100px;
  border-radius: 28px;
  aspect-ratio: 1/1;
  object-fit: cover;
`;

// 사용자 정보 - 팝업 컨텍스트
const ContextMenu = styled.div`
  position: absolute;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid var(--sub-dark-color);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  margin-top: -12px;
  z-index: 10;
  overflow: hidden;
`;

// 팝업 컨텍스트 항목
const ContextMenuItem = styled.div`
  padding: 8px 16px;
  font-size: 14px;
  color: var(--dark-color);
  cursor: pointer;
  &:hover {
    background: var(--sub-light-color);
  }
`;

const Info = styled.div`
  font-family: 'Gotham';
  font-size: 16px;
  line-height: 1;
  margin-top: 11px;

  #name-ko {
    font-family: 'Pretendard';
    font-size: 14px;
    color: var(--gray-color);
  }

  #email {
    font-weight: 300;
    color: #66666699;
    margin-top: 4px;
  }
`

export default UserProfile;